<template lang="pug">
transition(name="transition__slide_vertical", mode="out-in")
  slot
</template>

<script>
export default {
  name: 'transition-slide-vertical',
  props: {
    mode: String,
    appear: Boolean,
  },
};
</script>

<style>
.transition__slide_vertical-enter-active,
.transition__slide_vertical-leave-active {
  transition: top 0.5s ease-in-out;
}

.transition__slide_vertical-enter,
.transition__slide_vertical-leave-to {
  top: -100%;
}

.transition__slide_vertical-enter-to,
.transition__slide_vertical-leave {
}
</style>



// WEBPACK FOOTER //
// SlideVertical.vue?4b52524c